import React, { useState } from "react";
import {myGlobals, myUtilities} from "../../Utils";
import TrifectaCover from "../Common/TrifectaCover";
import PaymentInprogressEmail from "../../ModernUX/PaymentInprogressNotify";

class PaymentInProgressPage extends React.Component {
  
  constructor(props){
    super(props);
    this.paymentInProgressUI =  this.paymentInProgressUI.bind(this); 
  }
    paymentInProgressUI = () => {
      return <PaymentInprogressEmail/> ;                  
   };
   render() {
    return (myGlobals.currentTheme === "trifectaTheme.css" || myGlobals.currentTheme === 'modernUX.css')
      ? <TrifectaCover> {this.paymentInProgressUI()} </TrifectaCover>
      : this.paymentInProgressUI();
  }
}
export default PaymentInProgressPage;
